var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-overlay",on:{"click":_vm.close}}),_c('div',{staticClass:"modal-container",class:{'modal-container--right': _vm.position === 'right'},attrs:{"id":"modal"}},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }